import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "./hcaData";
import { HcaReveal, HcaEyebrow } from "./HcaReveal";

export const HcaFaq = () => (
    <section data-testid="hca-faq-section" className="max-w-4xl mx-auto px-6 py-20 lg:py-28">
        <HcaReveal>
            <HcaEyebrow>Questions</HcaEyebrow>
            <h2 className="font-display text-3xl sm:text-4xl text-[#0E1E3A] mt-3">Frequently asked</h2>
        </HcaReveal>
        <Accordion type="single" collapsible className="mt-8">
            {FAQS.map(([q, a], i) => (
                <AccordionItem key={q} value={`faq-${i}`} className="border-[#D8DEE6]">
                    <AccordionTrigger data-testid={`hca-faq-trigger-${i}`} className="text-left font-display text-lg text-[#0E1E3A] hover:no-underline">
                        {q}
                    </AccordionTrigger>
                    <AccordionContent className="text-[#5E6B7E] leading-relaxed">{a}</AccordionContent>
                </AccordionItem>
            ))}
        </Accordion>
    </section>
);
